/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */
import { Observable, ReplaySubject } from 'rxjs';
import { share } from 'rxjs/operators';

// shareReplay will be deprecated in RxJs 8, this is an equivalent of shareReplay({refCount: true, bufferSize: 1})
// https://github.com/ReactiveX/rxjs/blob/7.1.0/src/internal/operators/shareReplay.ts#L137
export const shareReplayLastWithRefCount = <T>(source$: Observable<T>): Observable<T> =>
  source$.pipe(
    share({
      connector: () => new ReplaySubject(1),
      resetOnError: true,
      resetOnComplete: false,
      resetOnRefCountZero: true,
    }),
  );
